import React from "react";
import { Flex, useDisclosure } from "@chakra-ui/react";

import { ActionButton } from "./ActionButton";

import CreateClassroomModal from "js/components/ClassroomCreate";
import useStore from "stores/index";
import { CombineClassesModal } from "../CombineClasses/CombineClassesModal";
import { FocusLibraryDrawer } from "../FocusLibraryDrawer";
import { getFeatures } from "stores/classwizeConfigStore";

interface Props {
	teacherClassroomsEnabled: boolean;
	isMonitoringAuthorised: boolean;
}

export function CtxBarRight(props: Props): JSX.Element {
	const stores = useStore();

	const createClassModal = useDisclosure();
	const combineClassesModal = useDisclosure();
	const focusLibraryDrawer = useDisclosure();

	async function handleSubmitCreateClassroom(
		classroomName: string,
		code: string,
		codeExpiry: string,
		isMonitoringClass: boolean,
		isPinned: boolean
	) {
		return await stores.classroom.handleAddClassroom({
			name: classroomName,
			inviteCode: code,
			inviteCodeExpiry: codeExpiry,
			isMonitoringClass,
			pinned: isPinned,
		});
	}

	const store = useStore();
	const showFocusLibraryButton = getFeatures(store).includes("focus");

	return (
		<>
			<Flex columnGap={8} ml={"auto"}>
				{props.teacherClassroomsEnabled && <ActionButton handleClick={createClassModal.onOpen} icon={"fa-plus"} label="Add Class" />}
				<ActionButton handleClick={combineClassesModal.onOpen} icon={"fa-merge"} label="Combine Classes" />
				{showFocusLibraryButton && (
					<>
						<ActionButton handleClick={focusLibraryDrawer.onOpen} icon={"fa-arrows-to-eye"} label="Focus Library" />
						<FocusLibraryDrawer isOpen={focusLibraryDrawer.isOpen} closeDrawer={focusLibraryDrawer.onClose} />
					</>
				)}
			</Flex>

			<CreateClassroomModal
				open={createClassModal.isOpen}
				onClose={createClassModal.onClose}
				heading={"Create a new class"}
				isMonitoringAuthorised={props.isMonitoringAuthorised}
				onSubmit={handleSubmitCreateClassroom}
				bodyClass="addClass_modal"
			/>
			<CombineClassesModal open={combineClassesModal.isOpen} onClose={combineClassesModal.onClose} />
		</>
	);
}
